import React, { useState } from "react";
import { Box, Grid, Typography, Button, MenuItem } from "@mui/material";
import styles from "./HomeNew.module.css";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/Latest Logo.png";
import Footer from "./HomeFooter";
import { IoHomeOutline } from "react-icons/io5";
import { PiBookOpenUser } from "react-icons/pi";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import { GoLightBulb } from "react-icons/go";
import { RxHamburgerMenu } from "react-icons/rx";
import Fade from "react-reveal/Fade";
import { customTextColor } from "../../utils/const";

const SafeJob = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <Box>
      <Box className={styles.home_header}>
        <span>
          <img src={logo} alt="Logo" />
        </span>
        <span className={styles.nav_links}>
          <a onClick={() => navigate("/")}>
            <IoHomeOutline style={{ fontSize: "22px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Home
            </b>
          </a>

          <a onClick={() => navigate("/our-platform")}>
            <GoLightBulb style={{ fontSize: "18px" }} />
            <b
              style={{
                marginLeft: "5px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Our Platform
            </b>
          </a>
          <a onClick={() => navigate("/about-us")}>
            <PiBookOpenUser style={{ fontSize: "22px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              About us
            </b>
          </a>
          <a onClick={() => navigate("/contact-us")}>
            <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
            <b
              style={{
                marginLeft: "10px",
                fontSize: "16px ",
                fontWeight: "500",
              }}
            >
              Contact us
            </b>
          </a>
          <Box className={styles.login_btn}>
            <a onClick={() => navigate("/login")}>
              <b>Login</b>
            </a>
          </Box>
        </span>

        {/* Hamburger menu for mobile view */}
        <span className={styles.hamburger_icon} onClick={toggleMenu}>
          <RxHamburgerMenu style={{ fontSize: "30px" }} />
        </span>

        {/* Mobile Menu */}
        {menuOpen && (
          <Box className={styles.mobile_menu}>
            <a onClick={() => navigate("/")}>
              <IoHomeOutline style={{ fontSize: "22px" }} />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                Home
              </Typography>
            </a>

            <a onClick={() => navigate("/our-platform")}>
              <GoLightBulb style={{ fontSize: "20px" }} />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                Our Platform
              </Typography>
            </a>
            <a onClick={() => navigate("/about-us")}>
              <PiBookOpenUser style={{ fontSize: "22px" }} />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                About us
              </Typography>
            </a>
            <a onClick={() => navigate("/contact-us")}>
              <TfiHeadphoneAlt style={{ fontSize: "18px" }} />
              <Typography
                style={{
                  marginLeft: "10px",
                  fontSize: "16px",
                  fontWeight: "500",
                }}
              >
                Contact us
              </Typography>
            </a>
            <Box className={styles.login_btn}>
              <a onClick={() => navigate("/login")}>
                <b>Login</b>
              </a>
            </Box>
          </Box>
        )}
      </Box>
      <Box sx={{ padding: "35px" }} id="home" />
      <Box className={styles.home_structure}>
        <Fade bottom delay={200}>
          <Box className={styles.configuration_structure}>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                sm={4}
                md={3}
                sx={{ backgroundColor: "#fff", border: "2px solid #f2f2f2" }}
              >
                <Box className={styles.security_body}>
                  <Box
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{
                      color: customTextColor,
                      fontSize: "17px !important",
                      margin: "4px 0",
                    }}
                    onClick={() => navigate("/privacy-policy")}
                  >
                    <b>Privacy Policy</b>
                  </Box>
                </Box>
                <Box
                  className={styles.security_body}
                  style={{ margin: "14px 0" }}
                  onClick={() => navigate("/refund-policy")}
                >
                  <Box
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Refund Policy</b>
                  </Box>
                </Box>
                <Box
                  className={styles.security_body}
                  style={{ margin: "14px 0" }}
                  onClick={() => navigate("/term-of-use")}
                >
                  <Box
                    aria-controls="panel1-content"
                    id="panel1-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Website Terms of Use</b>
                  </Box>
                </Box>

                <Box
                  className={styles.security_body}
                  style={{ margin: "14px 0" }}
                  onClick={() => navigate("/data-backup-policy")}
                >
                  <Box
                    aria-controls="panel2-content"
                    id="panel2-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Data Backup Policy</b>
                  </Box>
                </Box>
                <Box
                  className={styles.security_body}
                  style={{ margin: "14px 0" }}
                  onClick={() => navigate("/safe-job-search")}
                >
                  <Box
                    aria-controls="panel2-content"
                    id="panel2-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                     <b style={{ borderBottom: "2px solid #1991e0" }}>Safe Job Search & Applies Security </b>
                  </Box>
                </Box>
                <Box
                  className={styles.security_body}
                  onClick={() => navigate("/reporting-fraud")}
                  style={{ margin: "14px 0" }}
                >
                  <Box
                    aria-controls="panel3-content"
                    id="panel3-header"
                    sx={{ color: customTextColor, fontSize: "17px !important" }}
                  >
                    <b>Reporting fraud</b>
                  </Box>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                sm={8}
                md={9}
                style={{
                  paddingLeft: window.innerWidth < 600 ? "15px" : "0",
                }}
              >
                <Box
                  className={styles.employer_details}
                  sx={{ lineHeight: "2" }}
                >
                  {/* <Box className={styles.employer_details}> */}
                  <Grid
                    item
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    style={{
                      padding: "10px 30px 30px 20px",
                      backgroundColor: "#fff",
                    }}
                  >
                    <Box>
                      <Typography
                        sx={{ fontSize: "20px !important", userSelect: "none" }}
                      >
                        <b>Safe Job Search & Applies Security Center</b>
                      </Typography>

                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        The Company ensure to provide you a safe environment to
                        search jobs and manage your career on povital.in. For a
                        safe and secure web experience, we suggest you to take a
                        few simple security precautions when evaluating job
                        postings on povital.in and job opportunities that you
                        may receive via email/ phone.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        It has come to our notice that sometimes few
                        unscrupulous elements approach candidates claiming to be
                        our associates or partners and charge fees in lieu of
                        job offers. Please note the Company does not authorize
                        any agency/partner to collect fees against job offers.
                        In order to avoid such elements and you do not fall for
                        their tricks, we urge you to make a note of the
                        following:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        <ul>
                          <li>
                            The Company recommends jobseekers to be alert &
                            verify the legitimacy of such offers
                          </li>
                          <li>
                            Be cautious of any job appointment confirmation
                            without any interview with the prospective employer
                          </li>
                          <li>
                            Verify the URL or web link before sharing any
                            personal /bank account /credit card/ or any other
                            sensitive information
                          </li>
                        </ul>
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        We further suggest the following identifiers to screen
                        such fraudulent job offers. Company or individual
                        seeking upfront fees through bank in individual name or
                        through wire transfer.
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "16px !important",
                          marginTop: "15px",
                          userSelect: "none",
                        }}
                      >
                        If the company or an individual provides an offer letter
                        without an interview. The email address used is from
                        free email address and not from company domain. User is
                        advised to search for contact information on search
                        engines to know if the individuals involved in job scams
                        earlier. If the job requires upfront payment for a job
                        offer/processing of your application/processing of
                        visa/immigration fees etc.
                      </Typography>
                      <Typography
                        sx={{ fontSize: "16px !important", userSelect: "none" }}
                      >
                        If the company seeks your personal information/ bank
                        related information (like credit card details/bank
                        account details)
                      </Typography>
                    </Box>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Fade>
      </Box>
      <Footer />
    </Box>
  );
};

export default SafeJob;
